import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { GET, GET_TYPES } from '@hobs/constants/phases';

export function getPhases() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('phases')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET.REQUEST };
  }
  function success(response) {
    return { type: GET.SUCCESS, response };
  }
  function failure(error) {
    return { type: GET.FAILURE, error };
  }
}

export function getPhaseTypes() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('common/phaseTypes')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET_TYPES.REQUEST };
  }
  function success(response) {
    return { type: GET_TYPES.SUCCESS, response };
  }
  function failure(error) {
    return { type: GET_TYPES.FAILURE, error };
  }
}
